var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module cercaliagl/control/InfoMap
 */
import Control from './Control';
import MapControls from './MapControls';
import VInfoMap from '../view/VInfoMap';
/**
 * @classdesc
 *
 * @extends {Control}
 */
var InfoMap = /** @class */ (function (_super) {
    __extends(InfoMap, _super);
    /**
     * @constructor
     */
    function InfoMap() {
        var _this = this;
        var vInfoMap = new VInfoMap();
        var element = vInfoMap.getElement();
        _this = _super.call(this, {
            element: element,
            target: null,
            name: MapControls.INFOMAP,
        }) || this;
        /**
         * @private
         * @type {VInfoMap}
         */
        _this.vInfoMap_ = vInfoMap;
        /**
         * @private
         * @type {import('../InfoMap').default|undefined}
         */
        _this.infoMap_ = undefined;
        /**
         * @private
         */
        _this.element_ = element;
        return _this;
    }
    /**
     * @param {import('../InfoMap').default} infoMap Info Map.
     */
    InfoMap.prototype.update = function (infoMap) {
        this.infoMap_ = infoMap;
        var title = this.infoMap_.getTitle();
        var content = this.infoMap_.getContent();
        this.vInfoMap_.setTitle(title);
        this.vInfoMap_.setContent(content);
    };
    /**
     * Close popup.
     */
    InfoMap.prototype.closePopup = function () {
        this.vInfoMap_.hide(false);
    };
    /**
     * Show popup
     */
    InfoMap.prototype.showPopup = function () {
        this.vInfoMap_.show(false);
    };
    return InfoMap;
}(Control));
export default InfoMap;
//# sourceMappingURL=InfoMap.js.map